import React from 'react'
import "./HeroWds.css"
// import heroimage from '../Images/heroimage.png'
import heroimage from '../Images/heroimage2.png'
const HeroWds = () => {
    return (
        <div id='herowds'>
            <div className="section">
                <div className="container">
                    <h1 className='heroHeading'>
                        <span className='heroSpan'>Best Website</span> Development Services in India - Build Smart with Bastionex
                    </h1>
                    <div className="imageBox">
                        <img src={heroimage} alt="error" className='heroImage'/>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default HeroWds